import {VoucherApi} from "../Api/types";
import {createContext, ReactNode, useState} from "react";
import UserTokenContext from "../User/UserTokenContext";
import {api} from "../Api/api";

interface VouchersContextApi {
    vouchers: VoucherApi[] | undefined;
    syncVouchers: (userId: number | undefined, placeId: string | undefined, forceSync?: boolean) => Promise<VoucherApi[] | undefined>;
    loadingVouchers: boolean;
}

export const VouchersContext = createContext<VouchersContextApi>({
    vouchers: undefined,
    syncVouchers: async () => [],
    loadingVouchers: false,
});

interface Props {
    children: ReactNode;
}

const VouchersProvider = ({children}: Props) => {
    const [vouchers, setVouchers] = useState<VoucherApi[] | undefined>();
    const [userId, setUserId] = useState<number>();
    const [placeId, setPlaceId] = useState<string>();
    const [loading, setLoading] = useState(false);

    const fetchVouchers = async () => {
        const token = UserTokenContext.getToken();
        setLoading(true);

        try {
            const res = await api.getVouchers(token);
            setVouchers(res);

            return res;
        } catch (err) {
            setVouchers(undefined);

            return undefined;
        } finally {
            setLoading(false);
        }
    }

    const syncVouchers = async (newUserId: number | undefined, newPlaceId: string | undefined, forceSync?: boolean) => {
        if (loading) return;

        setUserId(newUserId);
        setPlaceId(newPlaceId);

        if (!newUserId) {
            setVouchers([]);

            return;
        }

        const shouldSync = newUserId !== userId || newPlaceId !== placeId || vouchers === undefined;

        if (!shouldSync && !forceSync) return;

        return fetchVouchers();
    }

    return <VouchersContext.Provider
        value={{
            vouchers,
            syncVouchers,
            loadingVouchers: loading
        }}>
        {children}
    </VouchersContext.Provider>
}

export default VouchersProvider;